import { RestrictionsPayload } from 'common/types/filters';
import { atomFamily } from 'recoil';

export const restrictionsState = atomFamily<RestrictionsPayload | null, string>({
  key: 'restrictionsState',
  default: null,
});
